//@ts-check

/**
 *
 * @enum {string}
 * @readonly
 */
export const Layouts = {
  /**@readonly */
  COMPLETE: 'extensao_completo',
  /**@readonly */
  COMPACT: 'extensao_compacto',
  /**@readonly */
  MULTI_LAB: 'laboratorios_multi',
};